module.exports = __webpack_public_path__ + "img/detail.6b4081c2.png";